// extracted by mini-css-extract-plugin
export default {"disabledRow":"CampaignPlannerInstanceDetail_disabledRow__4f-SH","statusSelector":"CampaignPlannerInstanceDetail_statusSelector__QUGAc"};